import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { isPrivateCommunity } from "@circle-react/helpers/communityHelpers";
import { isPrivateSpace } from "@circle-react/helpers/spaceHelpers";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { newSessionPath } from "@circle-react/helpers/urlHelpers";
import { useIsIframeEmbed } from "@circle-react/hooks/useIsIframeEmbed";

import { t } from "@/i18n-js/instance";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

import { useCurrentPostHelpers } from "../../useCurrentPostHelpers";
import { CommentsBanner } from "./CommentsBanner";
import { CustomCommentsBanner } from "./CustomCommentsBanner";

export const GatedComments = ({ post, space }) => {
  const { currentCommunity, currentUser } = usePunditUserContext();
  const {
    showGatedCommentSectionAtBottom: shouldShowGatedCommentSectionAtBottom,
    showGatedCommentSectionAtTop: shouldShowGatedCommentsAtTop,
    isSharedPostViewWithMinimalLayout,
  } = useCurrentPostHelpers();
  const isIframeEmbed = useIsIframeEmbed();

  const isLoggedIn = !!currentUser;
  const communityIsPrivate = isPrivateCommunity(currentCommunity);

  const lockedPostCtaContent = {
    heading: currentCommunity.locked_post_cta_heading || t("login_to_comment"),
    body: currentCommunity.locked_post_cta_body,
    buttonLabel: currentCommunity.locked_post_cta_button_text || t("log_in"),
    buttonLink:
      currentCommunity.locked_post_cta_button_url ||
      newSessionPath({
        params: {
          post_login_redirect: window.location.href,
        },
      }),
  };

  const containerClassNames = classNames(
    anchorClassNames({
      "gated-post--standard-layout": !post.minimal_layout,
      post__logged_out_comments: !communityIsPrivate,
    }),
    "py-10 px-7 text-center",
    {
      "border-t border-primary":
        isSharedPostViewWithMinimalLayout ||
        shouldShowGatedCommentSectionAtBottom,
      "border-b border-primary":
        !isSharedPostViewWithMinimalLayout && shouldShowGatedCommentsAtTop,
    },
  );

  if (
    (communityIsPrivate || !space || isPrivateSpace(space)) &&
    currentCommunity.custom_cta_for_share_links
  ) {
    return (
      <CustomCommentsBanner
        containerClassNames={containerClassNames}
        lockedPostCtaContent={lockedPostCtaContent}
      />
    );
  }
  if (post.is_comments_enabled && !isLoggedIn) {
    return (
      <CommentsBanner
        containerClassNames={containerClassNames}
        isIframeEmbed={isIframeEmbed}
        currentCommunity={currentCommunity}
      />
    );
  }

  return null;
};
